import api from './api';

// Theatre schedule (Use Case 1.1). Doctors may only change their own sessions;
// hospital edits and groups are admin-only — the backend enforces both.
const scheduleService = {
  week: (start) => api.get('/schedule/week', { params: { start } }).then((r) => r.data),
  createBlocks: (payload) => api.post('/schedule/blocks', payload).then((r) => r.data.blocks),
  updateBlock: (bid, payload) => api.put(`/schedule/blocks/${bid}`, payload).then((r) => r.data.block),
  // The session's patients, in order: [{ patient_id, planned_procedure, auth_number }] → the saved list
  setPatients: (bid, patients) => api.put(`/schedule/blocks/${bid}/patients`, { patients }).then((r) => r.data.patients),
  deleteBlock: (bid) => api.delete(`/schedule/blocks/${bid}`).then((r) => r.data),
  copyWeek: (fromStart, toStart) => api.post('/schedule/copy-week', { fromStart, toStart }).then((r) => r.data.copied),
  createHospital: (hname) => api.post('/schedule/hospitals', { hname }).then((r) => r.data.hospital),
  saveGroup: (group) =>
    (group.gid
      ? api.put(`/schedule/groups/${group.gid}`, group)
      : api.post('/schedule/groups', group)
    ).then((r) => r.data),
  deleteGroup: (gid) => api.delete(`/schedule/groups/${gid}`).then((r) => r.data),
};

export const errText = (err) => err?.response?.data?.err || err?.message || 'Something went wrong.';

export default scheduleService;
